/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import AssociateAccountEdit from "../../../../../containers/Accounts/BeneficiaryEditAccount/AssociateAccountEdit";
import GSTVerification from "../../../../../containers/Settings/GSTDetails";
import {
  beneVerifyThisGST,
  resetBeneVerifyThisGst,
} from "../../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import Validation from "../../../../../utils/validation";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import GstDetails from "../../../../_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../_utils/AccountCreationComponents/PanDetails";
import CommonLayout from "../../../../_utils/CommonLayout";
import LargePopupRedirect from "../../../../_utils/CommonPopups/CommonLargePopupRedirect";
import BeneAccountDetailsPopup from "../../BeneAccountDetailsPopup";
import "./index.css";

const BeneAccountStepPAN = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  setLookupNext,
  lookupNext,
  setIsNextButtonEnabled,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  accountType,
  setAccountType,
  setShutViewAll,
  disableCreateNext,
  setDisableCreateNext,
  type,
  previousId,
  setIsActive,
  isActive,
  beneLookError,
  setHideBlock,
  setHideCreate,
  setNonArchive,
  setPreviousBankNo,
  setIsLinkedAccount,
  isButtonDisabled,
  setPayload,
  payload,
  setShowAccInfo,
  handleDeSelectConfirm,
  showRejectTnxPopup,
  setRejectTxnPopup,
  showRejectAllTxnReson,
  setShowRejectAllTxnReson,
  GSTStatus,
  setGSTStatus,
  setNewData,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [focusState] = useState({});
  const associatedAccountRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [GSTLinked, setGSTLinked] = useState(false);
  const [activeTab, setActiveTab] = useState("Active");
  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [isApprovedState, setIsApprovedState] = useState([]);
  const [slideDirection, setSlideDirection] = useState("right");
  const [beneDetails, setBeneDetails] = useState(false);
  const [beneAccountId, setBeneAccountId] = useState("");

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );
  const { beneVerifyGST, isGSTLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const addSpacesToNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  const details =
    !beneLookLoading &&
    !verifyPANisLoading &&
    beneLookData?.status !== true &&
    verifiedPan &&
    panNumber?.length === GlobalConfiguration.panLength;

  const ActiveData = () => {
    setIsActive(false);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    if (activeTab === "Inactive") setSlideDirection("left");
    setActiveTab("Active");
    setIsPending(false);
    setNonArchive(false);
    setIsLinkedAccount(false);
    setAccountType({
      type: "",
      id: "",
    });
    setHideBlock(false);
    setShowAccInfo(false);
  };

  const DeactiveData = () => {
    setIsActive(true);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    setIsPending(false);
    if (activeTab === "Active") setSlideDirection("right");
    setActiveTab("Inactive");
    setNonArchive(false);
    setIsLinkedAccount(false);
    setShowAccInfo(false);
    setAccountType({
      type: "",
      id: "",
    });
  };

  useEffect(() => {
    if (payload?.gstin?.length === 15) {
      let aa = payload.gstin.substring(2, payload.gstin.length - 3);
      if (aa === panNumber && beneVerifyGST?.status === true) {
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);
        if (aa !== panNumber && beneVerifyGST?.status === true) {
          setGSTLinked(false);
        }
        setIsNextButtonEnabled(true);
      }
    } else if (
      payload?.gstin?.length === 0 &&
      verifiedPan &&
      !verifyPANisLoading
    ) {
      setGSTStatus(null);
    }
  }, [
    beneVerifyGST,
    GSTStatus,
    gstVerified,
    payload.gstin,
    verifyPANisLoading,
  ]);

  useEffect(() => {
    if (!beneLookData?.status) {
      let aa = payload.gstin.substring(2, payload.gstin.length - 3);
      if (!GSTStatus && GSTStatus != null) {
        setIsNextButtonEnabled(true);
      } else if (GSTStatus && disableCreateNext && aa === panNumber) {
        setIsNextButtonEnabled(false);
      }
    }
  }, [GSTStatus]);

  useEffect(() => {
    if (!beneLookData?.status) {
      let aa = payload.gstin.substring(2, payload.gstin.length - 3);
      if (
        verifiedPan === true &&
        GSTStatus &&
        payload?.gstin?.length > 0 &&
        payload?.gstin?.length === 15 &&
        gstVerified === true &&
        aa === panNumber
      ) {
        setIsNextButtonEnabled(false);
      } else if (
        !beneLookLoading &&
        !verifyPANisLoading &&
        beneLookError === true &&
        verifiedPan &&
        panNumber?.length === 10 &&
        payload?.gstin?.length === 0
      ) {
        setIsNextButtonEnabled(false);
      } else {
        setIsNextButtonEnabled(true);
      }
    }
  }, [gstVerified, GSTStatus]);

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData = viewAccountDetailData?.beneficiary_accounts[0];
      if (beneficiaryData) {
        setPayload((prevPayload) => ({
          ...prevPayload,

          gstin: beneficiaryData.gstin_detail || "",
        }));

        if (beneficiaryData.gstin) {
          dispatch(
            beneVerifyThisGST({
              gstin: beneficiaryData.gstin,
            }),
          );
        }
      }
    }
  }, [viewAccountDetailData, viewAccountDetailLoading, dispatch]);

  useEffect(() => {
    if (payload?.gstin?.length === 15 && !customErrors["gstin"]) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));

      dispatch(beneVerifyThisGST({ search_string: payload.gstin }));
    }
  }, [payload.gstin]);

  useEffect(() => {
    if (!isGSTLoading) {
      if (beneVerifyGST?.status === true) {
        setGstVerified(true);
      } else if (beneVerifyGST?.status === false) {
        setGstVerified(false);
      } else {
        setGstVerified(null);
      }
    }
  }, [beneVerifyGST, isGSTLoading]);

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));

    if (name === "gstin") {
      setGstVerified(null);
      setGSTStatus(null);
    }

    if (value) {
      setNewData({ [name]: value });
    }
    setNewData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value.length === 1) {
        return;
      }

      if (newValue.length < 15 && newValue.length > 0) {
        setGstVerified(false);
        setGSTStatus(false);
        setGSTLinked(false);
      }

      if (name === "gstin") {
        setLookupNext(false);
        dispatch(resetBeneVerifyThisGst());
      }
    }
  };

  let haveAcheived = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "archived";
  });
  let haveApproved = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });
  let haveDennied = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "denied";
  });
  let havePending = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBlock = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "blocked";
  });
  let haveRejected = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "rejected";
  });

  const isPanValid = verifiedPan === true;

  const isGstValid =
    payload?.gstin?.length === 0 || // GST optional
    (payload?.gstin?.length === 15 && GSTStatus === true);

  const isConfirmDisabled = !isPanValid || !isGstValid;

  useEffect(() => {
    if (
      payload.gstin?.length > 0 &&
      payload.gstin?.length === 15 &&
      beneVerifyGST?.status === true
    ) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
      setGSTStatus(true);
    }

    if (payload.gstin?.length > 0 && beneVerifyGST?.errors) {
      let errors = { ...customErrors };
      errors["gstin"] = beneVerifyGST.errors;
      setCustomErrors(errors);
      setGSTStatus(false);
    }
  }, [beneVerifyGST]);

  useEffect(() => {
    let haveApprovedLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id === previousId;
      },
    );

    let haveApprovedNotLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id !== previousId;
      },
    );

    if (haveApprovedLinked && haveApprovedNotLinked) {
      const newData = [...haveApprovedLinked, ...haveApprovedNotLinked];
      setIsApprovedState(newData);
    }
  }, [beneLookData]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.forEach((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [beneLookData]);

  useEffect(() => {
    if (beneVerifyGST?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: beneVerifyGST?.gstin_details?.business_name,
      });
    }
  }, [beneVerifyGST]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  return (
    <div className="w-width-full">
      {beneDetails && (
        <>
          <BeneAccountDetailsPopup
            closeBeneAccountDetailModal={() => {
              setBeneDetails(false);
            }}
            bene_account_id={beneAccountId}
            type={"bene_account_detail_modal"}
          />
        </>
      )}
      {showPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: beneVerifyGST?.gstin_details?.gstin_no,
            })
          }
          closeiconhandleFunction={() => setShowPopup(false)}
        >
          <GSTVerification
            gst_number={beneVerifyGST?.gstin_details?.gstin_no}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto Qsmd:!pb-padding-md">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <PanDetails
              verifiedPan={verifiedPan}
              verifyPANisLoading={verifyPANisLoading}
              panNumber={panNumber}
              handlePanChange={(e) => {
                handlePanChange(e);
              }}
              panDetails={panDetails}
            />
            <div
              className="w-width-full"
              style={{
                display: type === "createFlow" && !verifiedPan ? "none" : "",
              }}
            >
              <GstDetails
                verifiedPan={verifiedPan}
                gstVerified={gstVerified}
                beneVerifyGST={beneVerifyGST}
                isGSTLoading={isGSTLoading}
                GSTLinked={GSTLinked}
                GstNumber={payload?.gstin}
                focusState={focusState}
                setShowPopup={setShowPopup}
                handleChange={handleChange}
              />
            </div>
          </div>

          {verifiedPan === true ? (
            <div className="w-width-full flex flex-col lg:max-w-[var(--create-box-width)]">
              <ConfirmBtnAccCreation
                type="pan"
                status={beneLookData?.status}
                lookupNext={lookupNext}
                GSTStatus={GSTStatus}
                isButtonDisabled={isConfirmDisabled}
                isGSTLoading={isGSTLoading}
                selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                not_selected={ICONS?.NOTSELECTED_WITH_GREY_CIRCLE}
                handleClick={() => {
                  if (isConfirmDisabled) return;
                  setIsApproved(false);
                  setLookupNext(true);
                  setIsArchived(false);
                  setIsDennied(false);
                  setIsPending(false);
                  setDisableCreateNext(false);
                  setHideBlock(false);
                  if (lookupNext) {
                    setHideCreate(false);
                    handleDeSelectConfirm();
                  } else {
                    setHideCreate(true);
                  }
                  setAccountType({ type: "", id: "", name: "" });
                  setDisableCreateNext(true);
                }}
              />

              <div
                style={{
                  visibility:
                    panNumber?.length === GlobalConfiguration.panLength
                      ? "visible"
                      : "hidden",
                }}
              >
                <AssociateAccountEdit
                  ActiveData={ActiveData}
                  DeactiveData={DeactiveData}
                  haveAcheived={haveAcheived}
                  haveDennied={haveDennied}
                  haveBlock={haveBlock}
                  haveRejected={haveRejected}
                  isApprovedState={isApprovedState}
                  haveApproved={haveApproved}
                  havePending={havePending}
                  isActive={isActive}
                  activeTab={activeTab}
                  setSlideDirection={setSlideDirection}
                  slideDirection={slideDirection}
                  setActiveTab={setActiveTab}
                  previousId={previousId}
                  addSpacesToNumber={addSpacesToNumber}
                  beneLookLoading={beneLookLoading}
                  verifiedPan={verifiedPan}
                  details={details}
                  setAccountId={setBeneAccountId}
                  setAccoutDetails={setBeneDetails}
                />
              </div>
            </div>
          ) : (
            <div
              className="w-width-full"
              style={{
                visibility: "hidden",
              }}
            ></div>
          )}
        </CommonLayout>
      </div>
    </div>
  );
};
export default BeneAccountStepPAN;
